import WarningIcon from "@mui/icons-material/Warning";
import {
	Box,
	Button,
	Grid,
	Skeleton,
	Tooltip,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TitledBox from "../../../../components/TitledBox";
import { useGetMicrosoftOAuthQuery } from "../../integrationsApiSlice";
import { DisconnectMicrosoftOauth } from "./disconnect";

const Microsoft = (props) => (
	<svg
		viewBox="0 0 256 256"
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		preserveAspectRatio="xMidYMid"
		{...props}
	>
		<path fill="#F1511B" d="M121.666 121.666H0V0h121.666z" />
		<path fill="#80CC28" d="M256 121.666H134.335V0H256z" />
		<path fill="#00ADEF" d="M121.663 256.002H0V134.336h121.663z" />
		<path fill="#FBBC09" d="M256 256.002H134.335V134.336H256z" />
	</svg>
);

export const MicrosoftOauth = ({
	isLoadingUser,
	hasActiveMicrosoftOauth,
	hasActiveSMTPConnection,
}) => {
	const { t } = useTranslation();
	const [connectionType, setConnectionType] = useState(null);

	const { data: response, isLoading } = useGetMicrosoftOAuthQuery(
		{ type: connectionType },
		{ skip: !connectionType }
	);

	const handleOpenUrl = () => {
		if (!response?.data) return;

		window.location.href = response?.data;
	};

	useEffect(() => {
		handleOpenUrl();
	}, [response]);

	return (
		<Grid container spacing={5}>
			<Grid size={6}>
				<TitledBox
					title="Microsoft OAuth"
					color="#0067b8"
					sx={{
						width: "100%",
						height: "100%",
						position: "relative",
					}}
				>
					<Box sx={{ padding: "24px 10px 20px 20px" }}>
						{(isLoadingUser || isLoading) && (
							<Box sx={{ display: "flex", gap: "40px" }}>
								<Skeleton
									sx={{ borderRadius: 1 }}
									variant="rectangular"
									width={191.75}
									height={35.8}
								/>
								<Skeleton
									sx={{ borderRadius: 1 }}
									variant="rectangular"
									width={176.417}
									height={35.8}
								/>
							</Box>
						)}
						{hasActiveMicrosoftOauth === false &&
							!isLoadingUser &&
							!isLoading && (
								<Box
									sx={{ display: "flex", gap: "40px", alignItems: "center" }}
								>
									<Box
										sx={{
											display: "flex",
											gap: "10px",
											alignItems: "center",
										}}
									>
										{hasActiveSMTPConnection && (
											<Tooltip
												title={
													<Typography
														variant="p"
														sx={{ fontSize: "9pt" }}
														component="span"
													>
														{t("disconnect_smtp_to_connect_ms_oauth")}
													</Typography>
												}
												placement="top-end"
											>
												<WarningIcon color="warning" />
											</Tooltip>
										)}
										<Button
											loading={isLoading}
											variant="contained"
											disabled={isLoading || hasActiveSMTPConnection}
											onClick={() => setConnectionType("personal")}
											sx={{
												position: "relative",
												overflow: "hidden",
												display: "flex",
												alignItems: "center",
												gap: "8px",
												background: "#0067b8",
												":disabled": {
													opacity: "0.8",
													color: "#fff",
													background: "rgba(128,128,128,0.75)",
												},
											}}
										>
											{t("link_personal_account")}
											<Microsoft />
										</Button>
									</Box>
									<Box
										sx={{
											display: "flex",
											gap: "10px",
											alignItems: "center",
										}}
									>
										{hasActiveSMTPConnection && (
											<Tooltip
												title={
													<Typography
														variant="p"
														sx={{ fontSize: "9pt" }}
														component="span"
													>
														{t("disconnect_smtp_to_connect_ms_oauth")}
													</Typography>
												}
												placement="top-end"
											>
												<WarningIcon color="warning" />
											</Tooltip>
										)}
										<Button
											loading={isLoading}
											variant="contained"
											disabled={isLoading || hasActiveSMTPConnection}
											onClick={() => setConnectionType("business")}
											sx={{
												position: "relative",
												overflow: "hidden",
												display: "flex",
												alignItems: "center",
												gap: "8px",
												background: "#0067b8",
												":disabled": {
													opacity: "0.8",
													color: "#fff",
													background: "rgba(128,128,128,0.75)",
												},
											}}
										>
											{t("link_business_account")}
											<Microsoft />
										</Button>
									</Box>
								</Box>
							)}
						{hasActiveMicrosoftOauth === true &&
							!isLoadingUser &&
							!isLoading && (
								<Box sx={{ display: "flex", gap: "40px" }}>
									<DisconnectMicrosoftOauth />
								</Box>
							)}
					</Box>
				</TitledBox>
			</Grid>
		</Grid>
	);
};
